import { readStrokeWidthUserUnits } from './svgStrokeConvert';

function parseMiterLimit(computed: CSSStyleDeclaration, element: Element): number {
  const fromStyle = parseFloat(computed.strokeMiterlimit);
  if (Number.isFinite(fromStyle) && fromStyle > 0) return fromStyle;
  const attr = element.getAttribute('stroke-miterlimit');
  const parsed = attr != null ? parseFloat(attr) : 4;
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 4;
}

/** Outward pad (user units) for axis-aligned bounds of stroked geometry. */
export function readStrokeBBoxPad(computed: CSSStyleDeclaration, element: Element): number {
  const strokeWidth = readStrokeWidthUserUnits(computed, element);
  if (!(strokeWidth > 0)) return 0;

  let pad = strokeWidth / 2;
  const lineJoin =
    computed.strokeLinejoin || element.getAttribute('stroke-linejoin') || 'miter';
  if (lineJoin === 'miter') {
    const miterLimit = parseMiterLimit(computed, element);
    pad = Math.max(pad, (strokeWidth / 2) * miterLimit);
  }

  return pad;
}

/**
 * Expand a local getBBox() by painted stroke extent.
 * Handles degenerate line geometry (zero width or height) as well as filled shapes.
 */
export function expandBBoxForStroke(
  element: Element,
  bbox: DOMRect,
  computed: CSSStyleDeclaration,
  hasStroke: boolean
): DOMRect {
  let { x, y, width, height } = bbox;
  const pad = hasStroke ? readStrokeBBoxPad(computed, element) : 0;
  const fallbackPad = 0.5;

  if (!(width > 0) || !(height > 0)) {
    const effectivePad = pad > 0 ? pad : fallbackPad;
    if (!(width > 0)) {
      width = effectivePad * 2;
      x -= effectivePad;
    }
    if (!(height > 0)) {
      height = effectivePad * 2;
      y -= effectivePad;
    }
    return new DOMRect(x, y, width, height);
  }

  if (!(pad > 0)) return bbox;
  return new DOMRect(x - pad, y - pad, width + pad * 2, height + pad * 2);
}
